/**
 * Tablet-review helpers. They are deliberately pure: rendering decides which
 * reading a designer selected; this layer refuses candidates and resolves stable
 * W-labels against the current sketch only at the explicit Apply step.
 */
export function reviewableSlots(session) {
  return (Array.isArray(session?.slots) ? session.slots : [])
    .filter((slot) => ['candidate', 'confirmed'].includes(slot.status) && Number.isFinite(slot.valueUnits) && slot.valueUnits > 0)
    .map((slot) => ({ ...slot }));
}

export function applyReviewedMeasurements(session, sketchWalls, selectedSlotIds, setWallLength) {
  const selected = new Set(selectedSlotIds ?? []);
  const byLabel = new Map((sketchWalls ?? [])
    .filter((wall) => Number.isInteger(wall.wallNumber))
    .map((wall) => [`W${wall.wallNumber}`, wall]));
  const applied = [];
  const skipped = [];
  for (const slot of reviewableSlots(session)) {
    if (!selected.has(slot.id)) continue;
    if (slot.status !== 'confirmed') { skipped.push(slot.id); continue; }
    const wall = byLabel.get(slot.wallLabel);
    if (!wall || setWallLength(wall.id, slot.valueUnits) !== true) { skipped.push(slot.id); continue; }
    applied.push(slot.id);
  }
  return { applied, skipped };
}
